import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=67fd85ac&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=67fd85ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fd85ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fd85ac')) {
      api.createRecord('67fd85ac', component.options)
    } else {
      api.reload('67fd85ac', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=67fd85ac&scoped=true&", function () {
      api.rerender('67fd85ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lAPyEWY4MgMa/JS/comp/PopupDialog.vue"
export default component.exports